'use strict';
angular.module('eventAnalysisMainModule', []).controller('eventAnalysisMainCtrl', ['$scope', '$rootScope', '$sce', 'trsHttpService', '$filter', '$timeout', 'eventAnalysisService', '$state', 'dateFilter', 'trsspliceString', 'modalDialog', 'globleParamsSet',
    function($scope, $rootScope, $sce, trsHttpService, $filter, $timeout, eventAnalysisService, $state, dateFilter, trsspliceString, modalDialog, globleParamsSet) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                'CURRPAGE': 1,
                'PAGESIZE': 20,
                'ITEMCOUNT': 0,
                'PAGECOUNT': 1,
            };
            $scope.data = {
                eventAnaysisExit: {
                    item: ''
                },
                searchWord: '',
                index: '',
                customConfig: {
                    maxDate: globleParamsSet.dateFormat(new Date()),
                }
            };
            $scope.params = {
                typeid: 'widget',
                serviceid: 'eventmgr',
                modelid: 'hoteventlist',
                page_no: $scope.page.CURRPAGE - 1,
                page_size: $scope.page.PAGESIZE,
                keyword: '',
                search_date: '',
            };
            $scope.status = {
                params: {
                    'PageSize': $scope.page.PAGESIZE,
                    'CurrPage': $scope.page.CURRPAGE,
                },
                isSearch: false,
                copyCurrPage: 1,
                showKeywords: '',
                isDefaultImg: false,
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            getEventAnalysisData();
            getEventanalysisRights();
        }

        /**
         * [getEventanalysisRights description] 选题事件显示隐藏权限
         * @return {[type]} [description] null
         */
        function getEventanalysisRights() {
            var params = {
                'Classify': 'sjfx',
                'ModalName': '事件分析',
                'methodname': 'queryOperKeysOfNormalModal',
                'serviceid': 'mlf_metadataright'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                .then(function(data) {
                    $scope.eventRights = {};
                    angular.forEach(data, function(value, key) {
                        $scope.eventRights[value.OPERNAME] = true;
                    });
                });
        }

        /**
         * [eventAnalysisInit description]监听左侧栏事件分析更新数据
         */
        $scope.$on('eventAnalysisInit', function () {
            $scope.data.searchWord = '';
            getEventAnalysisData();
        });

        /**
         * [getEventAnalysisData description]事件分析展示数据
         * @return {[type]} [description]
         */
        function getEventAnalysisData(){
            if ($scope.status.isSearch) {
                $scope.status.isSearch = false;
            } else {
                $scope.params.keyword = '';
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.data.eventAnaysisExit.item = data.CONTENT.map(function(value, key){
                    var obj = {};
                    obj = {
                        ID: value.ID,
                        TITLE: value.TITLE,
                        PLACE: value.PLACE,
                        MAXRATETIME: value.MAXRATETIME,
                        PEOPLE: value.PEOPLE,
                        VOLUMNCOUNT: value.VOLUMNCOUNT,
                        IMAGEURL: !value.IMAGEURL || value.IMAGEURL == '未获取' ? './images/event_main.png' : value.IMAGEURL.split(';')[0],
                        ISUSEDEFAULTIMG: !!(value.IMAGEURL == '' || value.IMAGEURL == '未获取'),
                    };
                    return obj;
                });
                if ($scope.status.isDefaultImg){
                    $scope.data.eventAnaysisExit.item[0].IMAGEURL = './images/event_main.png';
                    $scope.data.eventAnaysisExit.item[0].ISUSEDEFAULTIMG = true;
                }
                $scope.page.ITEMCOUNT = data.TOTALELEMENTS;
                $scope.page.PAGECOUNT = data.TOTALPAGES;
            });
        }

        /**
         * [show_eana_edit_panel description] 编辑事件分析
         * @return {[type]} [description]
         */
        $scope.show_eana_edit_panel = function(index){
            $scope.showIndex = index;
        };
        $scope.show_eana_edit_panel1 = function(index){
            $scope.showIndex = -1;
        };

        /**
         * [pageChanged description]事件分析展示分页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.params.page_no = $scope.page.CURRPAGE - 1;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            getEventAnalysisData();
        };

        $scope.selectPageNum = function() {
            $scope.params.page_no = $scope.page.CURRPAGE - 1;
            $scope.params.page_size = $scope.page.PAGESIZE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
        };

        /**
         * [jumpToPage description:跳转指定页面]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            } else if ($scope.status.copyCurrPage < 1) {
                $scope.status.copyCurrPage = 1;
            }
            $scope.params.page_no = $scope.status.copyCurrPage - 1;
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            getEventAnalysisData();
        };
        // 新建事件分析
        $scope.newCreateEvent = function(){
            eventAnalysisService.newCreatEvent().then(function(){
            });
        };
        $scope.timeStamp = function(item) {
            return $filter('date')(item, 'yyyy-MM-dd');
        };
        // 编辑事件分析
        $scope.editCreateEvent = function(item){
            $scope.status.isDefaultImg = false;
            eventAnalysisService.newCreatEvent(item).then(function(){
            });
        };
        // 删除事件分析
        $scope.deleteEvent = function(item){
            $scope.status.isDefaultImg = false;
            var params = {
                typeid: 'widget',
                serviceid: 'eventmgr',
                modelid: 'delete',
                incidentid: item
            };
            modalDialog.confirmModal('删除提示', '是否确认删除？', function() {
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'GET').then(function(data) {
                    if (data) {
                        modalDialog.alertType('删除成功', '', 'success', false, function () {
                            getEventAnalysisData();
                        });
                    }
                });
            }, function(){
                return;
            });
        };

        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function(key, value) {
            if ($scope.data.fromdate) {
                $scope.params.search_date = $scope.data.fromdate + ';' + $scope.data.untildate;
            } else {
                $scope.params.search_date = '';
            }
            $scope.status.isSearchPage = true;
            getEventAnalysisData();
        };
        $scope.textSearch = function(ev) {
            $scope.status.isSearch = true;
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.status.params.CurrPage = $scope.page.CURRPAGE = 1;
                $scope.status.showKeywords = $scope.data.searchWord;
                $scope.params.keyword = $scope.data.searchWord;
                getEventAnalysisData();
            }
        };
        $scope.$on('addNewEventChange', function(e, v){
            if (v.operation == '新建事件'){
                $scope.status.isDefaultImg = true;
            }
            getEventAnalysisData();
        });
    }]);
